<script lang="ts">
  let {
    type = 'text',
    label = '',
    placeholder = '',
    value = $bindable(''),
    error = '',
    disabled = false,
    required = false,
    id = '',
    onfocus,
    onblur,
    oninput
  }: {
    type?: 'text' | 'email' | 'password' | 'search' | 'tel' | 'url' | 'number';
    label?: string;
    placeholder?: string;
    value?: string;
    error?: string;
    disabled?: boolean;
    required?: boolean;
    id?: string;
    onfocus?: (e: FocusEvent) => void;
    onblur?: (e: FocusEvent) => void;
    oninput?: (e: Event) => void;
  } = $props();
</script>

<div class="space-y-2">
  {#if label}
    <label
      for={id}
      class="block text-label text-gray-700 dark:text-dark-text-medium"
    >
      {label}
      {#if required}
        <span class="text-error ml-0.5">*</span>
      {/if}
    </label>
  {/if}

  <div class="relative">
    <input
      {type}
      {id}
      {placeholder}
      {disabled}
      {required}
      bind:value
      {onfocus}
      {onblur}
      {oninput}
      class="input {error ? 'input-error' : ''}"
      aria-invalid={error ? 'true' : undefined}
      aria-describedby={error ? `${id}-error` : undefined}
    />
    {#if error}
      <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
        <svg class="w-5 h-5 text-error" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </div>
    {/if}
  </div>

  {#if error}
    <p id="{id}-error" class="text-caption text-error flex items-center gap-1.5" role="alert">
      <svg class="w-3.5 h-3.5 shrink-0" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
      </svg>
      {error}
    </p>
  {/if}
</div>
